import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";

export default function AccountDeletedPage() {
  usePageMeta({
    path: "/account/deleted",
    title: "Account deleted , MediTalk",
    description:
      "Your MediTalk account has been deleted. Thanks for being part of the community.",
  });

  return (
    <div className="bg-white">
      <section className="bg-[var(--dark-bg)] grain-dark relative overflow-hidden min-h-[70vh] flex items-center">
        <div
          aria-hidden="true"
          className="absolute -top-32 -right-24 w-[420px] h-[420px] rounded-full bg-[var(--lime)]/10 blur-3xl pointer-events-none"
        />
        <div className="container-main py-16 md:py-24 relative z-10 max-w-2xl text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[var(--lime)]/12 border border-[var(--lime)]/30 mb-6">
            <Check size={26} className="text-[var(--lime)]" strokeWidth={3} />
          </div>
          <h1 className="font-['Outfit'] font-bold text-white tracking-tight text-3xl md:text-5xl mb-4 leading-[1.05]">
            Your MediTalk account has been deleted.
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto">
            Your personal details have been removed and you won't receive any
            further study invitations from us. A confirmation email is on its
            way.
          </p>
          <p className="text-[13px] text-white/55 leading-relaxed mt-5 max-w-xl mx-auto">
            A small number of records may be retained where the law requires it
            (e.g. payments already made, or adverse-event reports), as
            explained in our{" "}
            <Link
              to="/privacy"
              className="text-white underline decoration-[var(--lime)] decoration-2 underline-offset-2"
            >
              privacy notice
            </Link>
            . These do not include enough information to re-identify you.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[var(--lime)] text-[var(--dark-bg)] font-semibold text-sm hover:bg-[var(--lime-dark)] transition-all"
              data-testid="account-deleted-home"
            >
              Back to MediTalk
              <ArrowRight size={16} />
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-white/[0.06] text-white font-semibold text-sm border border-white/15 hover:bg-white/[0.1] transition-colors"
              data-testid="account-deleted-rejoin"
            >
              Join again
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
